import React from 'react'
import { Outlet } from "react-router-dom"
import Header from "./Header"
import Footer from "./Footer"
import { Suspense } from "react"
import { ProtectedRoute } from '../Routes/ProtectedRoutes'

export default function Layout() {
    return (
        <ProtectedRoute>
            <Header />
            <main>
                <Suspense fallback={<div>Loading...</div>}>
                    <Outlet />
                </Suspense>
            </main>
            <Footer />
        </ProtectedRoute>
    )
}